import * as React from "react"
import { ProjectEditor, ProjectEditorProps } from "./project_editor"
import { PublicShareSettings, PublicShareSettingsProvider } from "./public_share_settings"
import { PublicSplash } from "./public_splash"

interface PublicProjectEditorProps extends ProjectEditorProps {
  settings: PublicShareSettings
}

/** Public /share entry. Close to the regular editor, with its own share settings. */
export function PublicProjectEditor({ settings, ...props }: PublicProjectEditorProps) {
  return (
    <PublicShareSettingsProvider value={settings}>
      <ProjectEditor {...props} />
      <PublicSplash />
    </PublicShareSettingsProvider>
  )
}
